import React, {useMemo} from 'react';
import {classes, style} from './doppe-email-subscription-consent-element.st.css';
import {Checkbox, Icon, reactCreateMemo } from '@wix/devzai-utils-react';
import {CommonClasses, FlexLayout} from '@wix/devzai-common-client';
import IconChecked from '../subscribe-action-form/icons/checked.svg';
import {useBymoPageContextProps} from '../../doppe-sdk';
import {DoppeHideableValue, doppeHideableValueGetVisibleValue,} from '../../client-server-common';
import {useDoppeViewerLocales} from "../../client/doppe-viewer-locales/doppe-viewer-locales";

export namespace DoppeMarketingConsentElement {
    export interface Props {
        customText: DoppeHideableValue<string>;
        showCheckbox?: boolean;
        onChange?: (value: boolean) => void;
        value?: boolean;
        hasError?: boolean;
    }
}

export const DoppeEmailSubscriptionConsentElement = reactCreateMemo(function DoppeMarketingConsentElement(
    props: DoppeMarketingConsentElement.Props,
) {
    const {
        customText,
        onChange,
        value,
        showCheckbox,
        hasError,
    } = props;

    const { userDisplayName } = useBymoPageContextProps();

    const doppeViewerLocales = useDoppeViewerLocales();

    const text = useMemo(() => {
        const customTextValue = doppeHideableValueGetVisibleValue(customText, '').trim();
        if (customTextValue) {
            return customTextValue;
        } else if (showCheckbox) {
            return doppeViewerLocales['subscribeCheckBoxText']({
                username: userDisplayName,
            });
        } else {
            return doppeViewerLocales['subscribeConsentText']({
                username: userDisplayName,
            });
        }
    }, [customText, showCheckbox, userDisplayName]);

    return (
        <div className={style(classes.consentBox, { hasError: hasError })}>
            <div className={style(classes.consentBoxContainer, FlexLayout.row.alignToTop)}>
                {showCheckbox ? (
                    <Checkbox
                        className={style(classes.consentCheckbox)}
                        checked={value}
                        onCheckedChanged={onChange}
                    >
                        {(renderProps) => {
                            return (
                                <div className={style(classes.consentCheckboxView, {}, FlexLayout.centerContent, CommonClasses.button)}>
                                    {renderProps.checked ? <Icon icon={IconChecked} /> : null}
                                </div>
                            );
                        }}
                    </Checkbox>
                ) : null}
                <div className={style(classes.consentText, FlexLayout.row.alignToTop, CommonClasses.button)}
                    onClick={onChange ? () => onChange(!value) : undefined}
                >
                    {text}
                </div>
            </div>
            {hasError ? (
                <div className={style(classes.inputErrorMessage, {})}>{doppeViewerLocales['youMustAgree']}</div>
            ) : null}
        </div>
    );
});
